import theme from '../../../../themes/green';

const styles = {
  list: Object.assign(...theme.font, {
    padding: '0',
    listStyleType: 'none',
    label: {
      ...theme.font,
      fontSize: '11px',
      fontWeight: '400',
    },
    value: {
      fontSize: '11px',
      fontWeight: 'bold',
    },
  }),
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/Project/ProjectDetails/ProjectDetailsList/ProjectDetailsList.styles.js